import { supabase } from "@/supabase";

export const namespaced = true;

// Categories tal com les ha confirmat Supabase
export const state = {
    list: {},
};

// Fila de Supabase -> objecte que fa servir l'app (false = sense data)
export function fromRow(row) {
    return {
        id: row.id,
        name: row.name,
        laps: row.laps,
        sort_order: row.sort_order,
        version: row.version || 0,
        race_start: row.race_start || false,
        race_finish: row.race_finish || false,
    };
}

// Aplica els canvis pendents de desar sobre les dades confirmades
function applyPending(list, pending) {
    let out = { ...list };
    pending.forEach((op) => {
        if (op.type !== "updateCategory" || !out[op.id]) return;
        out[op.id] = fromRow({ ...out[op.id], ...op.fields });
    });
    return out;
}

function update(context, id, fields) {
    return context.dispatch(
        "sync/enqueue",
        { type: "updateCategory", id, fields },
        { root: true }
    );
}

export const mutations = {
    setCategories(state, data) {
        state.list = data;
    },
    applyRows(state, rows) {
        let categories = { ...state.list };
        (rows || []).forEach((row) => {
            const current = categories[row.id];
            if (current && current.version > (row.version || 0)) return;
            categories[row.id] = fromRow(row);
        });

        state.list = categories;
    },
};
export const actions = {
    async loadCategories(context) {
        const { data, error } = await supabase
            .from("categories")
            .select("*")
            .order("sort_order");
        if (error) {
            console.error("Error carregant categories", error);
            throw error;
        }

        let categories = {};
        data.forEach((row) => {
            categories[row.id] = fromRow(row);
        });

        context.commit("setCategories", categories);
    },

    startRace(context, params) {
        return update(context, params.id, {
            race_start: moment().valueOf(),
            race_finish: null,
        });
    },

    stopRace(context, params) {
        return update(context, params.id, { race_finish: moment().valueOf() });
    },

    updateSettings(context, params) {
        return update(context, params.id, { name: params.name, laps: params.laps });
    },

    resetRace(context, params) {
        return update(context, params.id, { race_start: null, race_finish: null });
    },
};
export const getters = {
    all: (state, getters, rootState) =>
        applyPending(state.list, rootState.sync.pending),

    getCategories: (state, getters) => (id) => {
        if (typeof id !== "undefined") {
            return getters.all[id] ? getters.all[id] : false;
        }

        return getters.all;
    },
};
